import { z } from 'zod'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'
import { createdAtSearchShape, creatorMemberSearchShape } from '@/utils/list-query.ts'

export const botListSearchSchema = z.object({
  current: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  id: z.uuid().optional().catch(undefined),
  keyword: z.string().trim().max(100).optional().catch(undefined),
  isEnabled: z.boolean().optional().catch(undefined),
  ...creatorMemberSearchShape,
  ...createdAtSearchShape,
  sortField: z.enum(['createdAt', 'name']).catch('createdAt'),
  sortOrder: z.enum(['asc', 'desc']).catch('desc')
})
export const botListPersistence = createListQueryPersistence('super-mega:bots:list-query', botListSearchSchema)
export type BotListSearch = z.infer<typeof botListSearchSchema>
